import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from '@bwoty-web/styleguide';

import styles from './SearchBarControls.scss';

export const SearchOptions = {
  departure: 'departure',
  dateFrom: 'dateFrom',
  dateTo: 'dateTo',
  tripLength: 'tripLength',
};

export const SearchBarControls = forwardRef((props, ref) => {
  const {
    isOpen,
    isLoading,
    departureField,
    dateFromField,
    dateToField,
    tripLengthField,
    onOpenPane,
    onSearch,
    buttonLabel,
  } = props;

  const className = classnames(styles.root, {
    [styles.isOpen]: isOpen,
  });

  return (
    <div className={className} ref={ref}>
      <div className={styles.container}>
        <div className={styles.row}>
          <div
            className={styles.control}
            onClick={() => onOpenPane(SearchOptions.departure)}
            role="presentation"
          >
            {departureField}
          </div>
        </div>
        <div className={classnames(styles.row, styles.row2x)}>
          <div
            className={styles.control}
            onClick={() => onOpenPane(SearchOptions.dateFrom)}
            role="presentation"
          >
            {dateFromField}
          </div>
          <div
            className={styles.control}
            onClick={() => onOpenPane(SearchOptions.dateTo)}
            role="presentation"
          >
            {dateToField}
          </div>
        </div>
        <div className={styles.row}>
          <div
            className={styles.control}
            onClick={() => onOpenPane(SearchOptions.tripLength)}
            role="presentation"
          >
            {tripLengthField}
          </div>
        </div>
        <div className={classnames(styles.row, styles.ctaRow)}>
          <div className={styles.control}>
            <Button
              theme="primary"
              onClick={onSearch}
              disabled={isLoading}
              className={styles.cta}
              data-test="lms-search-cta"
            >
              {buttonLabel}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
});

SearchBarControls.propTypes = {
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  onOpenPane: PropTypes.func,
  onSearch: PropTypes.func,
  departureField: PropTypes.node,
  dateFromField: PropTypes.node,
  dateToField: PropTypes.node,
  tripLengthField: PropTypes.node,
  buttonLabel: PropTypes.node,
};

SearchBarControls.defaultProps = {
  onOpenPane: () => {},
  onSearch: () => {},
};
